(function() {
  'use strict';

  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }

  function setCookie(name, value) {
    document.cookie = name + '=' + value + '; path=/; SameSite=Lax';
  }

  function initTopBar() {
    const topBar = document.querySelector('.js-top-bar');
    const closeButton = document.querySelector('.js-top-bar-close');
    
    if (!topBar) {
      return;
    }
    
    if (getCookie('top_bar_dismissed') === '1') {
      topBar.remove();
      return;
    }
    
    if (closeButton) {
      closeButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        setCookie('top_bar_dismissed', '1');
        topBar.remove();
      });
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTopBar);
  } else {
    initTopBar();
  }
})();
